export default __webpack_public_path__ + "static/media/icon-voucher-transaction.fcac8d22.svg";